module.exports = __webpack_public_path__ + "static/media/1015330.300265b5.png";